import {useState} from 'react'

import {Box} from 'src/components/Box'
import {Header4, SmallBody} from 'src/components/text'

import HoverOverlay from '../HoverOverlay'

const VideoCard: React.FunctionComponent<{
  title: string
  time: string
  heroUrl?: string
  link: string
}> = ({title, time, heroUrl, link}) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        textDecoration: 'none',
        color: 'inherit',
      }}
    >
      <Box
        width="100%"
        maxWidth="340px"
        height="180px"
        position="relative"
        borderRadius="8px"
        overflow="hidden"
        style={{boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'}}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            backgroundImage: heroUrl ? `url(${heroUrl})` : undefined,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundColor: heroUrl ? undefined : '#e0e0e0', // Fallback color
          }}
        />
        <HoverOverlay isVisible={isHovered}>
          <Header4 color={'#FFFFFF'}>{title}</Header4>
          <SmallBody>{time}</SmallBody>
        </HoverOverlay>
      </Box>
    </a>
  )
}

export default VideoCard
